import styled, { css } from 'styled-components';
import { pxToRem } from '../../../../../design-tokens/style-utilities';
export const receiptRowStyles = ({ theme, $justify = 'space-between', $align = 'start', }) => css `
	display: flex;
	flex-direction: row;
	justify-content: ${$justify};
	align-items: ${$align};
	gap: ${pxToRem(theme.spacing['200'])};
`;
export const StyledReceiptRow = styled.div `
	${receiptRowStyles}
`;
